var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimulationAndSandboxGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Video-Game-The-Sims--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Video Game The Sims Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 19h-0.5a0.25 0.25 0 0 1 -0.25 -0.25v-0.5a0.75 0.75 0 0 0 -1.5 0v0.5a0.25 0.25 0 0 1 -0.25 0.25h-0.5a0.75 0.75 0 0 0 0 1.5h0.5a0.25 0.25 0 0 1 0.25 0.25v0.5a0.75 0.75 0 0 0 1.5 0v-0.5a0.25 0.25 0 0 1 0.25 -0.25h0.5a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 3a0.75 0.75 0 0 0 0 -1.5h-0.5a0.25 0.25 0 0 1 -0.25 -0.25v-0.5a0.75 0.75 0 0 0 -1.5 0v0.5a0.25 0.25 0 0 1 -0.25 0.25h-0.5a0.75 0.75 0 0 0 0 1.5h0.5a0.25 0.25 0 0 1 0.25 0.25v0.5a0.75 0.75 0 0 0 1.5 0v-0.5A0.25 0.25 0 0 1 3.75 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.73 11.25h2.73a0.29 0.29 0 0 0 0.26 -0.16 0.31 0.31 0 0 0 0 -0.31l-4.79 -7.17a0.25 0.25 0 0 0 -0.31 -0.09 0.26 0.26 0 0 0 -0.14 0.29l1.76 7.06a0.51 0.51 0 0 0 0.49 0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72 12.91a0.29 0.29 0 0 0 -0.26 -0.16h-2.73a0.51 0.51 0 0 0 -0.49 0.38l-1.76 7.06a0.26 0.26 0 0 0 0.14 0.29 0.25 0.25 0 0 0 0.31 -0.09l4.78 -7.17a0.31 0.31 0 0 0 0.01 -0.31Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78 11.09a0.29 0.29 0 0 0 0.26 0.16h2.73a0.51 0.51 0 0 0 0.49 -0.38L9 3.81a0.26 0.26 0 0 0 -0.14 -0.29 0.25 0.25 0 0 0 -0.31 0.09l-4.76 7.17a0.31 0.31 0 0 0 -0.01 0.31Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77 12.75H4a0.29 0.29 0 0 0 -0.26 0.16 0.31 0.31 0 0 0 0 0.31l4.78 7.17a0.25 0.25 0 0 0 0.31 0.09 0.26 0.26 0 0 0 0.17 -0.29l-1.74 -7.06a0.51 0.51 0 0 0 -0.49 -0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.06a0.49 0.49 0 0 0 0.39 0.19h4.8a0.49 0.49 0 0 0 0.39 -0.19 0.48 0.48 0 0 0 0.09 -0.43L12 0.23a0.3 0.3 0 0 0 -0.58 0l-2.55 10.4a0.48 0.48 0 0 0 0.13 0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.54 12.94a0.49 0.49 0 0 0 -0.39 -0.19h-4.8a0.49 0.49 0 0 0 -0.39 0.19 0.48 0.48 0 0 0 -0.09 0.43l2.59 10.4a0.3 0.3 0 0 0 0.58 0l2.59 -10.4a0.48 0.48 0 0 0 -0.09 -0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimulationAndSandboxGames);
export default ForwardRef;